import { Injectable, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { FormsBase } from 'src/app/common-components/forms-base/forms-base';
import { CallCostDetailForm, CallCostDetailFormValue } from '../models/call-cost-detail-form';
import { CallCostDetailSaveModel } from '../models/call-cost-detail-save.model';
import { CallCostDetailView } from '../models/call-cost-detail-view.model';

@Injectable()
export class CallCostDetailFormService extends FormsBase implements OnDestroy {
   private destroyed$ = new Subject<void>();

   // regex for no special characters
   pattern = '^[a-zA-Z0-9 ]*$';

   numbersOnlyPattern = '^[0-9]{1,9}$';

   zeroOrOnePattern = '^[0-1]$';

   currencyPattern = '^[0-9]*[.]?[0-9]{1,4}$';

   constructor(fb: UntypedFormBuilder, private store: Store, private action: Actions) {
      super();

      const form: CallCostDetailForm = {
         providerId: fb.control(null, Validators.required),
         File: fb.control(null, Validators.required),
      };

      this.form = fb.group(form);
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   updateCallCost(callCost: CallCostDetailView): void {
      if (!callCost) {
         return;
      }

      const formValue = {
         destination: callCost.destination,
         area: callCost.area,
         zone: callCost.zone,
         rate:
            callCost?.rate != null && callCost.rate !== undefined
               ? callCost.rate % 1 === 0
                  ? callCost.rate + '.00'
                  : (callCost?.rate * 10) % 1 === 0
                  ? callCost?.rate + '0'
                  : callCost.rate
               : null,
         providerId: callCost.providerId,
      };

      this.form.patchValue(formValue);
      this.markAsUntouchedAndPristine();
   }

   getValue(providerCallRateId: number | null): CallCostDetailSaveModel {
      const value = this.form.value as CallCostDetailFormValue;
      return {
         File: value.File,
         providerId: value.providerId,
      };
   }
}
